var React = require('react');

function EllipseStroke (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"7.5","cy":"7.5","r":"7","fill":"#F4F4F4","stroke":"#101010"}));
}

EllipseStroke.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = EllipseStroke;

EllipseStroke.default = EllipseStroke;
